import { createApp, h }     from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import routePlugin          from "../ts/Plugins/routePlugin";


createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob('../ts/View/Pages/**/*.vue', {eager: true});

        return pages[`../ts/View/Pages/${name}.vue`];
    },
    setup({el, App, props, plugin}) {
        createApp({render: () => h(App, props)})
            .use(plugin)
            .use(routePlugin)
            .mount(el);
    },
});
